import { FC } from "react";
import { FieldHookConfig, useField } from "formik";

import InputField from "../../InputField/InputField";
import { InputFieldProps } from "../../InputField/types";

const FormikInputFieldLight: FC<InputFieldProps & FieldHookConfig<string>> = (
  props: InputFieldProps & FieldHookConfig<string>
) => {
  const [field, meta] = useField(props);

  return (
    <InputField
      {...props}
      {...field}
      {...(meta.touched &&
        meta.error &&
        props.type !== "hidden" && { errorMessage: meta.error })}
    />
  );
};

export default FormikInputFieldLight;
